import React from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';

type AreYouSureModalProps = {
  confirmationMessage: string | React.ReactNode;
  onConfirmClick: VoidFunction;
  onHide: VoidFunction;
  show: boolean;
  submitting?: boolean;
  yes?: string;
  no?: string;
};

const AreYouSureModal: React.FC<AreYouSureModalProps> = ({
  show,
  onHide,
  confirmationMessage,
  onConfirmClick,
  submitting,
  yes,
  no,
}) => {
  if (!show) {
    return null;
  }

  return (
    <Modal show={true} onHide={onHide}>
      <Modal.Header className="font-size-16 font-weight-bold" closeButton>
        Are you sure ?
      </Modal.Header>
      <Modal.Body>{confirmationMessage}</Modal.Body>
      <Modal.Footer className="mx-3 mt-3 px-0">
        <Button disabled={submitting} variant="outline-secondary" className="mx-2 px-4" onClick={onHide}>
          {no || 'No'}
        </Button>
        <Button className="px-4" disabled={submitting} onClick={onConfirmClick}>
          {submitting ? <Spinner animation="border" size="sm" variant="light" /> : yes || 'Yes'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AreYouSureModal;
